module.exports = __webpack_public_path__ + "img/communitMarketing.78bbdb40.jpg";